import {
  CREATE_FOLDER_REQUEST,
  CREATE_FOLDER_SUCCESS,
  CREATE_FOLDER_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const newFolder = (state = initialState, action) => {
  const types = {
    [CREATE_FOLDER_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [CREATE_FOLDER_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [CREATE_FOLDER_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default newFolder;
